'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.showStartChatInviteDialog = showStartChatInviteDialog;
exports.showRoomInviteDialog = showRoomInviteDialog;
exports.isValid3pidInvite = isValid3pidInvite;
exports.inviteUsersToRoom = inviteUsersToRoom;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MatrixClientPeg = require('./MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _MultiInviter = require('./utils/MultiInviter');

var _MultiInviter2 = _interopRequireDefault(_MultiInviter);

var _Modal = require('./Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _UserAddress = require('./UserAddress');

var _createRoom = require('./createRoom');

var _createRoom2 = _interopRequireDefault(_createRoom);

var _ = require('./');

var _2 = _interopRequireDefault(_);

var _dispatcher = require('./dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _DMRoomMap = require('./utils/DMRoomMap');

var _DMRoomMap2 = _interopRequireDefault(_DMRoomMap);

var _languageHandler = require('./languageHandler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Invites multiple addresses to a room
 * Simpler interface to utils/MultiInviter but with
 * no option to cancel.
 *
 * @param {string} roomId The ID of the room to invite to
 * @param {string[]} addrs Array of strings of addresses to invite. May be matrix IDs or 3pids.
 * @returns {Promise} Promise
 */
/*
Copyright 2016 OpenMarket Ltd
Copyright 2017, 2018 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

function inviteMultipleToRoom(roomId, addrs) {
    var inviter = new _MultiInviter2.default(roomId);
    return inviter.invite(addrs).then(function (states) {
        return _promise2.default.resolve({ states: states, inviter: inviter });
    });
}

function showStartChatInviteDialog() {
    var AddressPickerDialog = _2.default.getComponent("dialogs.AddressPickerDialog");

    _Modal2.default.createTrackedDialog('Start a chat', '', AddressPickerDialog, {
        title: (0, _languageHandler._t)('Start a chat'),
        description: (0, _languageHandler._t)("Who would you like to communicate with?"),
        placeholder: function placeholder(validAddressTypes) {
            // The set of valid address type can be mutated inside the dialog
            // when you first have no IS but agree to use one in the dialog.
            if (validAddressTypes.includes('email')) {
                return (0, _languageHandler._t)("Email, name or Matrix ID");
            }
            return (0, _languageHandler._t)("Name or Matrix ID");
        },
        validAddressTypes: ['mx-user-id', 'email'],
        button: (0, _languageHandler._t)("Start Chat"),
        onFinished: _onStartDmFinished
    }, /*className=*/null, /*isPriority=*/false, /*isStatic=*/true);
}

function showRoomInviteDialog(roomId) {
    var AddressPickerDialog = _2.default.getComponent("dialogs.AddressPickerDialog");

    _Modal2.default.createTrackedDialog('Chat Invite', '', AddressPickerDialog, {
        title: (0, _languageHandler._t)('Invite new room members'),
        button: (0, _languageHandler._t)('Send Invites'),
        placeholder: function placeholder(validAddressTypes) {
            // The set of valid address type can be mutated inside the dialog
            // when you first have no IS but agree to use one in the dialog.
            if (validAddressTypes.includes('email')) {
                return (0, _languageHandler._t)("Email, name or Matrix ID");
            }
            return (0, _languageHandler._t)("Name or Matrix ID");
        },
        validAddressTypes: ['mx-user-id', 'email'],
        onFinished: function onFinished(shouldInvite, addrs) {
            _onRoomInviteFinished(roomId, shouldInvite, addrs);
        }
    }, /*className=*/null, /*isPriority=*/false, /*isStatic=*/true);
}

/**
 * Checks if the given MatrixEvent is a valid 3rd party user invite.
 * @param {MatrixEvent} event The event to check
 * @returns {boolean} True if valid, false otherwise
 */
function isValid3pidInvite(event) {
    if (!event || event.getType() !== "m.room.third_party_invite") return false;

    // any events without these keys are not valid 3pid invites, so we ignore them
    var requiredKeys = ['key_validity_url', 'public_key', 'display_name'];
    for (var i = 0; i < requiredKeys.length; ++i) {
        if (!event.getContent()[requiredKeys[i]]) return false;
    }

    // Valid enough by our standards
    return true;
}

// TODO: Immutable DMs replaces this
function _onStartDmFinished(shouldInvite, addrs) {
    if (!shouldInvite) return;

    var addrTexts = addrs.map(function (addr) {
        return addr.address;
    });

    if (_isDmChat(addrTexts)) {
        var rooms = _getDirectMessageRooms(addrTexts[0]);
        if (rooms.length > 0) {
            // A Direct Message room already exists for this user, so reuse it
            _dispatcher2.default.dispatch({
                action: 'view_room',
                room_id: rooms[0],
                should_peek: false,
                joining: false
            });
        } else {
            // Start a new DM chat
            (0, _createRoom2.default)({ dmUserId: addrTexts[0] }).catch(function (err) {
                var ErrorDialog = _2.default.getComponent("dialogs.ErrorDialog");
                _Modal2.default.createTrackedDialog('Failed to start chat', '', ErrorDialog, {
                    title: (0, _languageHandler._t)("Failed to start chat"),
                    description: err && err.message ? err.message : (0, _languageHandler._t)("Operation failed")
                });
            });
        }
    } else if (addrTexts.length === 1) {
        // Start a new DM chat
        (0, _createRoom2.default)({ dmUserId: addrTexts[0] }).catch(function (err) {
            var ErrorDialog = _2.default.getComponent("dialogs.ErrorDialog");
            _Modal2.default.createTrackedDialog('Failed to start chat', '', ErrorDialog, {
                title: (0, _languageHandler._t)("Failed to start chat"),
                description: err && err.message ? err.message : (0, _languageHandler._t)("Operation failed")
            });
        });
    } else {
        // Start multi user chat
        var room = void 0;
        (0, _createRoom2.default)().then(function (roomId) {
            room = _MatrixClientPeg2.default.get().getRoom(roomId);
            return inviteMultipleToRoom(roomId, addrTexts);
        }).then(function (result) {
            return _showAnyInviteErrors(result.states, room, result.inviter);
        }).catch(function (err) {
            console.error(err.stack);
            var ErrorDialog = _2.default.getComponent("dialogs.ErrorDialog");
            _Modal2.default.createTrackedDialog('Failed to invite', '', ErrorDialog, {
                title: (0, _languageHandler._t)("Failed to invite"),
                description: err && err.message ? err.message : (0, _languageHandler._t)("Operation failed")
            });
        });
    }
}

function inviteUsersToRoom(roomId, userIds) {
    return inviteMultipleToRoom(roomId, userIds).then(function (result) {
        var room = _MatrixClientPeg2.default.get().getRoom(roomId);
        return _showAnyInviteErrors(result.states, room, result.inviter);
    }).catch(function (err) {
        console.error(err.stack);
        var ErrorDialog = _2.default.getComponent("dialogs.ErrorDialog");
        _Modal2.default.createTrackedDialog('Failed to invite', '', ErrorDialog, {
            title: (0, _languageHandler._t)("Failed to invite"),
            description: err && err.message ? err.message : (0, _languageHandler._t)("Operation failed")
        });
    });
}

function _onRoomInviteFinished(roomId, shouldInvite, addrs) {
    if (!shouldInvite) return;

    var addrTexts = addrs.map(function (addr) {
        return addr.address;
    });

    // Invite new users to a room
    inviteUsersToRoom(roomId, addrTexts);
}

// TODO: Immutable DMs replaces this
function _isDmChat(addrTexts) {
    if (addrTexts.length === 1 && (0, _UserAddress.getAddressType)(addrTexts[0]) === 'mx-user-id') {
        return true;
    } else {
        return false;
    }
}

function _showAnyInviteErrors(addrs, room, inviter) {
    // Show user any errors
    var failedUsers = (0, _keys2.default)(addrs).filter(function (a) {
        return addrs[a] === 'error';
    });
    if (failedUsers.length === 1 && inviter.fatal) {
        // Just get the first message because there was a fatal problem on the first
        // user. This usually means that no other users were attempted, making it
        // pointless for us to list who failed exactly.
        var ErrorDialog = _2.default.getComponent("dialogs.ErrorDialog");
        _Modal2.default.createTrackedDialog('Failed to invite users to the room', '', ErrorDialog, {
            title: (0, _languageHandler._t)("Failed to invite users to the room:", { roomName: room.name }),
            description: inviter.getErrorText(failedUsers[0])
        });
    } else {
        var errorList = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(failedUsers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var addr = _step.value;

                if (addrs[addr] === "error") {
                    var reason = inviter.getErrorText(addr);
                    errorList.push(addr + ": " + reason);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        if (errorList.length > 0) {
            // React 16 doesn't let us use `errorList.join(<br />)` anymore, so this is our solution
            var description = _react2.default.createElement(
                'div',
                null,
                errorList.map(function (e) {
                    return _react2.default.createElement(
                        'div',
                        { key: e },
                        e
                    );
                })
            );

            var _ErrorDialog = _2.default.getComponent("dialogs.ErrorDialog");
            _Modal2.default.createTrackedDialog('Failed to invite the following users to the room', '', _ErrorDialog, {
                title: (0, _languageHandler._t)("Failed to invite the following users to the %(roomName)s room:", { roomName: room.name }),
                description: description
            });
        }
    }

    return addrs;
}

function _getDirectMessageRooms(addr) {
    var dmRoomMap = new _DMRoomMap2.default(_MatrixClientPeg2.default.get());
    var dmRooms = dmRoomMap.getDMRoomsForUserId(addr);
    var rooms = dmRooms.filter(function (dmRoom) {
        var room = _MatrixClientPeg2.default.get().getRoom(dmRoom);
        if (room) {
            return room.getMyMembership() === 'join';
        }
    });
    return rooms;
}
//# sourceMappingURL=RoomInvite.js.map